import React from 'react';
import { Users, Code, Shield } from 'lucide-react';
import {useNavigate} from 'react-router-dom'

const PartnerPrograms = () => {
  const navigate = useNavigate();
  const programs = [
    {
      id: 1,
      title: 'Selling Partner',
      icon: Users,
      iconBg: 'bg-orange-100',
      iconColor: 'text-orange-600',
      cardBg: 'bg-white',
      description: 'Selling Partners position KGS Technologysolutions as part of broader customer portfolios or as independent offerings. They cultivate customer relationships, generate pipeline opportunities, and expand market reach across industries and geographies.Technology.'
    },
    {
      id: 2,
      title: 'Technology Partner',
      icon: Code,
      iconBg: 'bg-orange-100',
      iconColor: 'text-orange-600',
      cardBg: 'bg-white',
      description: 'Technology Partners connect their platforms with KGS Technologyto unify ERP, TMS, WMS, planning, and data systems into a single execution intelligence layer. Together, we eliminate fragmentation and enable real-time visibility, structured performance scoring, and prioritized operational action.'
    },
    {
      id: 3,
      title: 'Consulting Partner',
      icon: Shield,
      iconBg: 'bg-orange-100',
      iconColor: 'text-orange-600',
      cardBg: 'bg-white',
      description: 'Consulting Partners implement KGS Technologysolutions to support enterprise transformation, integration, change management, and managed service programs. Their expertise ensures structured deployment and sustained operational performance.'
    }
  ];

  return (
    <div className="w-full bg-gradient-to-b from-gray-50 to-white py-20 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-6">
            Partner Programs
          </h2>
          <p className="text-gray-500 text-xl max-w-4xl mx-auto">
            Choose the partnership model that aligns with your business goals and expertise
          </p>
        </div>

        {/* Partner Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {programs.map((program) => {
            const Icon = program.icon;
            return (
              <div
                key={program.id}
                className={` ${program.cardBg} rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 p-8 border border-gray-100 hover:border-orange-200 transform hover:-translate-y-2`}
              >
                {/* Icon */}
                <div className={`w-16 h-16 ${program.iconBg} ${program.iconColor} rounded-2xl flex items-center justify-center mb-6`}>
                  <Icon size={32} strokeWidth={2} />
                </div>

                {/* Title */}
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {program.title}
                </h3>

                {/* Description */}
                <p className="text-gray-600 leading-relaxed">
                  {program.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="text-center mt-16">
          <button 
          onClick={()=>{
            navigate("/contact");
            window.scrollTo({
              top:0,
              behavior: "smooth"
            })
          }}
          className="bg-orange-600 hover:bg-orange-700 text-white font-semibold px-8 py-4 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
            Become a Partner
          </button>
          <p className="text-gray-500 mt-4 text-sm">
            Join our growing partner ecosystem and drive success together
          </p>
        </div>
      </div>
    </div>
  );
};

export default PartnerPrograms;